export const labels = {
	standard: {
		label: "Label.MobileCreator.PhotoSelection.AddStandardPhoto",
		default: "Standard",
	},
	aiPhoto: {
		label: "Label.MobileCreator.PhotoSelection.AddAiPhoto",
		default: "AI photo",
	},
} as const;
